var _excluded = ["name", "error", "selectClassName", "className", "icon", "disabled", "size", "arrow", "htmlSize", "handleInputChange", "loadOptions", "onBlur", "onFocus", "onChange", "assistiveText", "autoFocus"],
  _excluded2 = ["ref"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
/* eslint-disable deprecation/deprecation */
import React from 'react';
import { ReactSelectWrapper, Icon, ClearIndicator } from '../reactselect/ReactSelect';
import { Down } from '@dfds-ui/icons';
import AsyncSelect from 'react-select/async';
import ErrorText from '../error-text/ErrorText';
import AssistiveText from '../assistive-text/AssistiveText';
import { theme } from '@dfds-ui/theme';
import { jsx as ___EmotionJSX } from "@emotion/react";
var AsyncSearchableSelect = function AsyncSearchableSelect(_ref) {
  var name = _ref.name,
    error = _ref.error,
    selectClassName = _ref.selectClassName,
    className = _ref.className,
    icon = _ref.icon,
    disabled = _ref.disabled,
    _ref$size = _ref.size,
    size = _ref$size === void 0 ? 'medium' : _ref$size,
    _ref$arrow = _ref.arrow,
    arrow = _ref$arrow === void 0 ? true : _ref$arrow,
    htmlSize = _ref.htmlSize,
    handleInputChange = _ref.handleInputChange,
    loadOptions = _ref.loadOptions,
    onBlur = _ref.onBlur,
    onFocus = _ref.onFocus,
    onChange = _ref.onChange,
    assistiveText = _ref.assistiveText,
    autoFocus = _ref.autoFocus,
    rest = _objectWithoutProperties(_ref, _excluded);
  var DropdownIndicator = function DropdownIndicator(props) {
    var _props$children = props.children,
      children = _props$children === void 0 ? ___EmotionJSX(Icon, {
        size: size,
        disabled: disabled
      }, icon || ___EmotionJSX(Down, null)) : _props$children,
      getStyles = props.getStyles,
      _props$innerProps = props.innerProps,
      ref = _props$innerProps.ref,
      restInnerProps = _objectWithoutProperties(_props$innerProps, _excluded2);
    return ___EmotionJSX("div", _extends({}, restInnerProps, {
      ref: ref,
      style: getStyles('dropdownIndicator', props)
    }), ___EmotionJSX("div", {
      style: {
        padding: "0 ".concat(theme.spacing.xxs)
      }
    }, children));
  };
  return ___EmotionJSX(ReactSelectWrapper, {
    error: error,
    size: size,
    className: className,
    arrow: arrow
  }, ___EmotionJSX(AsyncSelect, _extends({
    as: "Select",
    name: name,
    "aria-invalid": error,
    visualSize: size,
    size: htmlSize,
    isDisabled: disabled,
    classNamePrefix: "react-select",
    className: selectClassName,
    loadOptions: loadOptions,
    onInputChange: handleInputChange,
    onChange: onChange,
    onBlur: onBlur,
    onFocus: onFocus,
    autoFocus: autoFocus,
    components: {
      DropdownIndicator: DropdownIndicator,
      ClearIndicator: ClearIndicator
    }
  }, rest)), error ? ___EmotionJSX(ErrorText, {
    small: true
  }, error) : assistiveText && ___EmotionJSX(AssistiveText, null, assistiveText));
};
export default AsyncSearchableSelect;